import { useEffect, useState } from "react";
import { useZxing } from "react-zxing";
import { format } from "date-fns";
import LoadScreen from "../UI/LoadScreen";
import { useFindOfBarcodeMutation } from "../../features/CallApi";
import { Button, Col, Modal, Row } from "react-bootstrap";



export const Scanner = () => {
    const [data, setData] = useState("Not Found");

    const [stopScanning, setStopScanning] = useState(false);
    const [findOfBarcode, { isLoading: getingData }] = useFindOfBarcodeMutation()
    const [ticketData, setTicketData] = useState("");
    const [alert, setAlert] = useState(null)
    const startVibro = (timer) => {
        if ('vibrate' in navigator && typeof navigator.vibrate === 'function') {
            navigator.vibrate(timer);
        }
    }



    const {
        ref,
        torch: { on, off, isOn, isAvailable },
    } = useZxing({
        timeBetweenDecodingAttempts: 100,
        paused: stopScanning,
        onDecodeResult(result) {
            checkTicket(result.getText())
        },
    });

    const checkTicket = (result) => {
        setData(result)
        setStopScanning(true)
        findOfBarcode(result).unwrap().then(
            (r) => {
                setAlert("Check-in")
                setTicketData(r)
            }
        ).catch(
            (e) => {
                console.log(e)
                setTicketData(null)
                if (e.data.visitorStatus === 1) {
                    if ('vibrate' in navigator && typeof navigator.vibrate === 'function') {
                        startVibro([75, 50, 100, 50, 125]);
                    }
                    setAlert(`<span class="badge bg-danger fs-5">Гость уже на месте!!!</span>`)
                    setTicketData(e.data)
                }
                else if (e.status === 404) {
                    setAlert("ШК не найде в системе")
                }
                else {
                    setAlert("Ошибка в данных запроса")
                }
            }
        )
    }

    useEffect(() => {
        console.log(alert === null)
        if (alert === null) {
            setStopScanning(false)
        }
    }, [alert])

    return (
        <div>
            <Modal show={(alert !== null)} >
                <Modal.Header className="text-center">
                    <h5 className="w-100 mb-0">
                        Сообщение
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <p className="w-100 text-center">
                     <div dangerouslySetInnerHTML={{__html: alert}} />
                    </p>
                </Modal.Body>
                <Modal.Footer className="w-100">
                    <Button variant="light" className="w-100" onClick={() => { setAlert(null) }} >Ok</Button>
                </Modal.Footer>
            </Modal>
            <div className="btn-group mt-3 mb-3">
                <button className="btn btn-secondary" onClick={() => (isOn ? off() : on())}>
                    {isOn ? "выкл." : "вкл."} Подсветка</button>
                <button className="btn btn-warning" onClick={
                    () => {
                        setData("Not Found")
                        setTicketData(null)
                    }}>Сброс</button>
            </div>
            <Row>
                <Col md={6}>
                    {!getingData ?
                        <> {ticketData &&
                            <>
                                {ticketData.sessionEvent.typeOfEvent !== 7 ?
                                    <div>
                                        <table className="table table-striped">
                                            <tbody>
                                                <tr>
                                                    <td>Номер заказа</td>
                                                    <td>{ticketData.order}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Мероприятие</strong></td>
                                                    <td><strong>{ticketData.sessionEvent.title} {format(new Date(ticketData.sessionEvent.dateEvent), "dd.MM.yyyy")}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Ряд (место)</strong></td>
                                                    <td><strong>{ticketData.comment}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>Ф.И.О</td>
                                                    <td>{ticketData.name}</td>
                                                </tr>
                                                <tr>
                                                    <td>Телефон</td>
                                                    <td>{ticketData.commentLine2}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    :
                                    <div>
                                        <table className="table table-striped">
                                            <tbody>
                                                <tr>
                                                    <td>Ф.И.О</td>
                                                    <td><strong>{ticketData.name}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}><strong><div dangerouslySetInnerHTML={{ __html: ticketData.comment }} /></strong></td>
                                                </tr>
                                                <tr colSpan={2}>
                                                    <td colSpan={2} ><div className="d-flex"> Теги: <div dangerouslySetInnerHTML={{ __html: ticketData.commentLine2 }} /> | <div dangerouslySetInnerHTML={{ __html: ticketData.order }} /></div></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Мероприятие</strong></td>
                                                    <td><strong>{ticketData.sessionEvent.title} {format(new Date(ticketData.sessionEvent.dateEvent), "dd.MM.yyyy")}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </>
                        }</> : <LoadScreen />
                    }
                    <p className="mt-3 mb-3">Данные ШК: {data}</p>
                </Col>
                <Col>
                    <div>
                        <>
                            <video style={{ maxWidth: "100%" }} ref={ref} />
                            {/* {isAvailable ? (
                        <button onClick={() => (isOn ? off() : on())}>
                            {isOn ? "Turn off" : "Turn on"} torch
                        </button>
                    ) : (
                        <strong>Unfortunately, torch is not available on this device.</strong>
                    )} */}
                        </>
                    </div>
                    {/* <BarcodeScannerComponent
                torch={torch}
                delay={1000}
                stopStream={stopScanning}
                onUpdate={(err, result) => {
                    if (result) {
                        checkTicket(result);
                    }
                    // else setData("Not Found");
                }}
            /> */}
                </Col>
            </Row>
        </div>
    )
}
